import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="section bg-dark text-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 text-center text-lg-start wow fadeInUp">
            <p className="mb-2 mb-lg-0">
              Copyright © {new Date().getFullYear()} {" "}
              <a className="fw-600" href="/">
                <img 
                  src="images/rbwhite.svg" 
                  alt="Rafal Borzemski" 
                  style={{ verticalAlign: 'baseline', height: '12px', width: 'auto' }}
                />
              </a>
              . All Rights Reserved.
            </p>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
